import { fetchFamilyAttributes } from '@gn-audio/core/api/product-catalogue/fetch-family-attributes';
import { fetchGroup } from '@gn-audio/core/api/product-catalogue/fetch-group';
import { fetchGroupsAttributes } from '@gn-audio/core/api/product-catalogue/fetch-groups-attributes';
import { isImage } from '../utils/is-image';
import { exec } from './utils/filter-actions.exec';
import { prepare } from './utils/filter-actions.prepare';
import { process } from './utils/filter-actions.process';
var Option = (function () {
    function Option(option, mandatory) {
        if (option === void 0) { option = {}; }
        if (mandatory === void 0) { mandatory = false; }
        this.checked = false;
        this.disabled = false;
        this.image = !mandatory ? '' : option.image || '';
        this.key = option.pimKey || '';
        this.value = option.pimValue || '';
        this.title = option.title || '';
    }
    return Option;
}());
var Filter = (function () {
    function Filter(filter, mandatory) {
        var _this = this;
        if (filter === void 0) { filter = {}; }
        if (mandatory === void 0) { mandatory = false; }
        this.mandatory = Boolean(mandatory);
        this.description = filter.description;
        this.options = (filter.options || []).map(function (o) { return new Option(o, _this.mandatory); });
        this.title = filter.title;
    }
    Filter.prototype.selected = function () {
        return this.options.filter(function (o) { return o.checked; });
    };
    Filter.prototype.type = function () {
        return this.mandatory ? 'radio' : 'checkbox';
    };
    Filter.prototype.checkedIconType = function () {
        return this.mandatory ? 'radio_button_checked' : 'check_box';
    };
    Filter.prototype.uncheckedIconType = function () {
        return this.mandatory ? 'radio_button_unchecked' : 'check_box_outline_blank';
    };
    return Filter;
}());
var CustomizerSpotController = (function () {
    function CustomizerSpotController($scope, $q, $location, productContextService, sectionTogglerService) {
        var _this = this;
        this.$scope = $scope;
        this.$q = $q;
        this.$location = $location;
        this.productContextService = productContextService;
        this.sectionTogglerService = sectionTogglerService;
        this.initialize();
        this.$scope.onFilterChange = function (filter, option) {
            if (filter.mandatory) {
                if (option.checked) {
                    return;
                }
                filter.options
                    .filter(function (o) { return o.value !== option.value; })
                    .forEach(function (o) {
                    o.checked = false;
                });
                option.checked = true;
                _this.$scope.resetOptionalFilters();
            }
            else {
                option.checked = !option.checked;
            }
            _this.$scope.availableGroups = exec(_this.$scope.groups, _this.$scope.filters);
            _this.$scope.selectedGroup = _this.$scope.availableGroups[0];
            process(_this.$scope.availableGroups, _this.$scope.filters);
        };
        this.$scope.resetOptionalFilters = function () {
            _this.$scope.filters
                .filter(function (f) { return !f.mandatory; })
                .forEach(function (f) {
                f.options.forEach(function (o) {
                    o.checked = false;
                });
            });
        };
        this.$scope.shouldHideVariantSelector = function () { return _this.$scope.loading || (_this.$scope.filters.length === 0 && _this.$scope.availableGroups.length === 1); };
        this.$scope.getHexColor = function () {
            var _a, _b;
            return getColorStyles((_b = (_a = _this.$scope.selectedGroup) === null || _a === void 0 ? void 0 : _a.attributes.find(function (attr) { return (attr === null || attr === void 0 ? void 0 : attr.key) === 'Product_Mobcolorhex'; })) === null || _b === void 0 ? void 0 : _b.value);
        };
        this.$scope.getColorName = function () {
            var _a, _b;
            return (_b = (_a = _this.$scope.selectedGroup) === null || _a === void 0 ? void 0 : _a.attributes.find(function (attr) { return (attr === null || attr === void 0 ? void 0 : attr.key) === 'Product_Mobcolor'; })) === null || _b === void 0 ? void 0 : _b.value;
        };
        this.$scope.getProductType = function () {
            var _a, _b;
            return (_b = (_a = _this.$scope.selectedGroup) === null || _a === void 0 ? void 0 : _a.attributes.find(function (attr) { return (attr === null || attr === void 0 ? void 0 : attr.key) === 'Meta_Producttype'; })) === null || _b === void 0 ? void 0 : _b.valueInEnUs;
        };
        this.$scope.scrollToTechSection = function () {
            var element = document.getElementById('tech-section');
            if (element) {
                element.scrollIntoView({ behavior: 'smooth' });
                _this.sectionTogglerService.toggleSection('documents', false);
            }
        };
        this.$scope.filtersAvailable = function () {
            return _this.$scope.filters && _this.$scope.filters.length > 0;
        };
        var mandatoryFilterJsonWatcher = this.$scope.$watch('configuration.mandatoryFilterJson', function () {
            var scFilter;
            if (_this.$scope.configuration.mandatoryFilterJson.trim() === 'null') {
                return;
            }
            scFilter = JSON.parse(_this.$scope.configuration.mandatoryFilterJson);
            _this.$scope.filters.push(new Filter(scFilter, true));
            mandatoryFilterJsonWatcher();
        });
        var optionalFiltersJsonWatcher = this.$scope.$watch('configuration.optionalFiltersJson', function () {
            var scFilters;
            if (_this.$scope.configuration.optionalFiltersJson.trim() === 'null') {
                return;
            }
            scFilters = JSON.parse(_this.$scope.configuration.optionalFiltersJson);
            Array.prototype.push.apply(_this.$scope.filters, scFilters.map(function (f) { return new Filter(f); }));
            optionalFiltersJsonWatcher();
        });
        var selectedGroupsWatcher = this.$scope.$watch('configuration.selectedGroupIdsJson', function (newValue) {
            if (typeof newValue !== 'string' || newValue === '') {
                _this.$scope.configuration.selectedGroupIds = [];
            }
            else {
                _this.$scope.loading = true;
                _this.$scope.configuration.selectedGroupIds = newValue.split(',').map(function (x) { return Number(x); });
                _this.$q.when(fetchGroupsAttributes(_this.$scope.configuration.selectedGroupIds, "supported"))
                    .then(_this.initializeGroups.bind(_this))
                    .then(function () { _this.$scope.loading = false; }, function () { _this.$scope.loading = false; });
            }
            selectedGroupsWatcher();
        });
        var familyIdWatcher = this.$scope.$watch('configuration.familyId', function () {
            if (_this.$scope.configuration.selectedGroupIds.length === 0) {
                _this.$scope.loading = true;
                _this.$q.when(fetchFamilyAttributes(Number(_this.$scope.configuration.familyId), "supported"))
                    .then(_this.initializeGroups.bind(_this))
                    .then(function () { _this.$scope.loading = false; }, function () { _this.$scope.loading = false; });
            }
            familyIdWatcher();
        });
        this.$scope.$watch('selectedGroup', this.selectedGroupHandler.bind(this));
    }
    CustomizerSpotController.prototype.initialize = function () {
        this.$scope.loading = false;
        this.$scope.filters = [];
        this.$scope.configuration = {
            skuFromUrl: this.$location.hash(),
        };
    };
    CustomizerSpotController.prototype.initializeGroups = function (groups) {
        var _this = this;
        (groups || []).forEach(function (g) {
            g.images = g.images.filter(isImage);
        });
        this.$scope.groups = groups || [];
        this.$scope.availableGroups = groups || [];
        this.$scope.selectedGroup =
            groups.filter(function (x) { return x.sku === _this.$scope.configuration.skuFromUrl; })[0] ||
                groups.filter(function (x) { return x.groupId === Number(_this.$scope.configuration.defaultGroupId); })[0] ||
                groups[0];
        if (this.$scope.selectedGroup !== undefined) {
            prepare(this.$scope.selectedGroup, this.$scope.filters);
            this.$scope.availableGroups = exec(this.$scope.groups, this.$scope.filters);
            process(this.$scope.availableGroups, this.$scope.filters);
        }
    };
    CustomizerSpotController.prototype.handleGroupState = function (_a) {
        var groupState = _a.groupState, pageUrl = _a.pageUrl;
        if (typeof groupState !== 'number') {
            return;
        }
        if (groupState >= 3) {
            this.$scope.pageUrl = pageUrl;
        }
        this.$scope.isDiscontinued = groupState < 3;
    };
    CustomizerSpotController.prototype.selectedGroupHandler = function () {
        var _this = this;
        var selectedGroup = this.$scope.selectedGroup;
        if (!selectedGroup) {
            return;
        }
        this.$location.hash(selectedGroup.sku);
        this.productContextService.setContext(selectedGroup);
        this.$q.when(fetchGroup(selectedGroup.groupId))
            .then(function (g) { _this.$scope.uniqeSellingPoint = g.uniqueSellingPoint; });
        this.handleGroupState(selectedGroup);
        this.$location.replace();
    };
    CustomizerSpotController.$inject = ['$scope', '$q', '$location', 'productContextService', 'sectionTogglerService'];
    return CustomizerSpotController;
}());
export { CustomizerSpotController };
var getColorStyles = function (colorValue) {
    if (!colorValue) {
        return '';
    }
    var colors = colorValue.split('|');
    if (colors.length === 0) {
        return '';
    }
    var percents = 0;
    var delta = Math.floor(100 / colors.length);
    return colors.reduce(function (accumulator, color) {
        return accumulator + ", #" + color + " " + percents + "%, #" + color + " " + (percents += delta) + "%";
    }, 'linear-gradient(45deg') + ')';
    ;
};
